import { FC } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';
import { selectSmallSize } from '../../../store/modules/template/selectors';

import Slide from './Slide';
import TemplateListWithSliderWrapper from './Wrapper';
import { useFetchTemplates } from './hooks';

const TemplateListWithSlider: FC = () => {
  const templateList = useSelector(templateSelectors.selectTemplateList);
  const currentTemplateId = useFetchTemplates();

  return (
    <TemplateListWithSliderWrapper>
      {templateList.map(({ meta, templateId }) => {
        const { media, defaultTarget } = meta;
        const defaultMedia = media[defaultTarget];
        const { url: preview } = selectSmallSize(defaultMedia.thumb);
        const isActive = currentTemplateId === templateId;

        return <Slide key={templateId} {...{ templateId, isActive, preview }} />;
      })}
    </TemplateListWithSliderWrapper>
  );
};

export default TemplateListWithSlider;
